import React from 'react';
import PageShell from '../../components/PageShell';

interface AdminPageShellProps {
  title: string;
  description?: string;
  /** Back link rendered in the global header (for detail pages) */
  backUrl?: string;
  /** Right-aligned action buttons for the page (e.g. "Create …") */
  actions?: React.ReactNode;
  /** Render the title row in the body as well as the global header. */
  showHeading?: boolean;
  children: React.ReactNode;
}

/**
 * Kept as a name, not as an implementation — this is now a pass-through to the
 * shared <PageShell>.
 *
 * The admin suite got this scaffold first, and it is the pattern P3-08
 * generalises: register the page with the global header, then render one
 * consistent title / description / actions row above the content. Thirteen admin
 * pages already rely on it, so it stays as a name while the behaviour moves to
 * the shared component the rest of the Pro app can use too.
 */
const AdminPageShell: React.FC<AdminPageShellProps> = ({
  title,
  description,
  backUrl,
  actions,
  showHeading = true,
  children,
}) => (
  <PageShell
    title={title}
    description={description}
    backUrl={backUrl}
    actions={actions}
    showHeading={showHeading}
  >
    {children}
  </PageShell>
);

export default AdminPageShell;
